import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  Router,
  NavigationEnd,
  Event as NavigationEvent,
} from '@angular/router';
import { Subject, Observable, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { AppFilter } from '@app/shared/models';
import { AuthenticationService } from 'src/modules/core/services';
@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>();
  isBackground: boolean;
  FADetails;
  user = JSON.parse(window.localStorage.getItem('user'));
  TwoFactorDate;
  organizationId: string = window.localStorage.getItem('organizationId');
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'appConfigId',
        op: 'cn',
        data: 'TWO_FACTOR_AUTH_ACTIVATION_DATE',
      },
    ],
  };
  filter: AppFilter = new AppFilter();
  applicationConfig;
  usedRecoveryCode: boolean = false;
  private eventSubscription: Subscription;

  constructor(
    private router: Router,
    private location: Location,
    private walletService: EwalletService,
    private userSvc: AuthenticationService
  ) {
    this.eventSubscription = this.userSvc.getEvent().subscribe((event) => {
      if (event) {
        this.ngOnInit();
      }
    });
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event: NavigationEvent) => {
        if (event instanceof NavigationEnd) {
          console.log(event);
          let url = this.location.path();
          if (
            url.split('/')[2] == 'dashboard' ||
            url.split('/')[2] == 'application'
          ) {
            this.isBackground = true;
          } else {
            this.isBackground = false;
          }
        }
      });
  }

  ngOnInit(): void {
    if (this.user.totpEnabled) {
      this.get2FADetails();
    }
    const recovery = window.localStorage.getItem('recoveryCodes');
    if (recovery === 'true') {
      this.usedRecoveryCode = true;
    }
    this.filter = new AppFilter({ sidx: 'appConfigId', rows: 10 });
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.getPage(1);
  }
  ngOnDestroy(): void {
    // unsubscribe all subsciptons
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.eventSubscription.unsubscribe();
  }
  get2FADetails() {
    this.walletService
      .get2FADetails({
        appUserId: this.user.appUserId,
      })
      .subscribe(
        (res: any) => {
          this.FADetails = res;
          // res.ewalletActivated
          //   ? this.router.navigate(['/contractor/wallet/activate'])
          //   : '';
        },
        (error) => {}
      );
  }
  isFutureDate(dateString: string): boolean {
    const currentDate = new Date();
    const comparisonDate = new Date(dateString);
    const isToday =
      comparisonDate.getFullYear() === currentDate.getFullYear() &&
      comparisonDate.getMonth() === currentDate.getMonth() &&
      comparisonDate.getDate() === currentDate.getDate();
    return isToday || comparisonDate > currentDate;
  }
  getPage(page) {
    this.filter.page = page;
    this.walletService
      .get2FAConfig({ configId: 'TWO_FACTOR_AUTH_ACTIVATION_DATE' })
      .subscribe(
        (res: any) => {
          this.applicationConfig = res.value;
        },
        (error) => {}
      );
  }
}
